/*
 * Percentage stats - count-up on scroll.
 *
 * Each figure carries the target number in data-to and starts at 0 in the
 * markup, so a page with JS off, or a viewer who asked for reduced motion,
 * still reads the real number rather than a stuck zero: the fallback path
 * writes the final value immediately instead of animating to it.
 *
 * The observer unobserves after the first crossing - the number counts up once
 * per page view, not every time the section scrolls back into view.
 */
(function () {
  var REDUCED =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function format(value, decimals) {
    return decimals > 0 ? value.toFixed(decimals) : String(Math.round(value));
  }

  function run(figure) {
    if (figure.dataset.ptStatDone === '1') return;
    figure.dataset.ptStatDone = '1';

    var num = figure.querySelector('[data-pt-stat-num]');
    if (!num) return;

    var to = parseFloat(figure.dataset.to);
    if (!isFinite(to)) return;

    var decimals = parseInt(figure.dataset.decimals || '0', 10) || 0;
    var duration = parseInt(figure.dataset.duration || '1600', 10) || 0;

    if (REDUCED || duration <= 0) {
      num.textContent = format(to, decimals);
      return;
    }

    var start = null;
    function step(now) {
      if (start === null) start = now;
      var t = Math.min(1, (now - start) / duration);
      num.textContent = format(to * easeOutCubic(t), decimals);
      if (t < 1) {
        window.requestAnimationFrame(step);
      } else {
        num.textContent = format(to, decimals);
      }
    }
    window.requestAnimationFrame(step);
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var figures = scope.querySelectorAll('[data-pt-stat]');
    if (!figures.length) return;

    var pending = [];
    for (var i = 0; i < figures.length; i++) {
      if (figures[i].dataset.ptStatInit === '1') continue;
      figures[i].dataset.ptStatInit = '1';
      pending.push(figures[i]);
    }
    if (!pending.length) return;

    // Reduced motion, or no observer to hang the trigger on: write the final
    // numbers now rather than leaving a column of zeroes on the page.
    if (REDUCED || !('IntersectionObserver' in window)) {
      pending.forEach(run);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          run(entry.target);
          obs.unobserve(entry.target);
        });
      },
      { threshold: 0.35 }
    );
    pending.forEach(function (figure) {
      observer.observe(figure);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  // Re-run when the theme editor re-renders the section.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
